export default "__VITE_ASSET__DDk2rH9V__"